module.exports = __webpack_public_path__ + "img/upload-remark.8a1d0915.png";